import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { useMediaQuery } from 'react-responsive';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import {
  MEDIA_QUERY_SMALL_SCREEN,
  MEDIA_QUERY_MEDIUM_SCREEN_850,
} from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrModalV2, { MODAL_THEME_FIXED_FOOTER_BUTTON } from 'client/components/SrModalV2/SrModalV2';
import SrButton, {
  SR_BUTTON_THEME_BLUR,
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_ORANGE_INVERTED,
} from 'client/components/SrButton/SrButton';
import SrFormikField, { SR_FIELD_THEME_PARTNER_FORM } from 'client/components/SrFormikField';

function getFormFields() {
  return [
    {
      id: 'unArchiveReason',
      title: 'Why are you un-archiving',
      properties: {
        placeholder: 'Write un-archive reason here...',
      },
      type: 'long_text',
      validations: ['required'],
    },
  ];
}

const SrUnArchiveAppModalSunScreen = ({ onClose, onUnArchive }) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });
  const isMediumScreen = useMediaQuery({
    query: MEDIA_QUERY_MEDIUM_SCREEN_850,
  });

  const onSubmit = (formValues) => {
    onUnArchive(formValues);
  };

  return (
    <SrModalV2
      centerContent
      closeOnBackgroundClick
      showCloseButton={false}
      contentMaxWidth={!isSmallScreen ? '375px' : null}
      padding={isSmallScreen ? 'calc(100vh - 660px) 0 0 0' : '0 0 120px 0'}
      contentPadding="0"
      onClose={onClose}
      theme={isSmallScreen ? MODAL_THEME_FIXED_FOOTER_BUTTON : null}
      buttonTheme={isSmallScreen ? SR_BUTTON_THEME_ADOBE_GREY : SR_BUTTON_THEME_BLUR}
    >
      <SrBox
        borderRadius={isMediumScreen ? '14px' : '24px'}
        backgroundColor="white"
        boxShadow="0px 15px 26px rgba(212, 212, 212, 0.17)"
        boxSizing="border-box"
        maxWidth="375px"
        width={isSmallScreen ? 'calc(100vw - 20px)' : '375px'}
        padding="48px 40px 40px"
        margin={isMediumScreen ? '0 auto' : null}
      >
        <SrBox
          margin="0 auto"
          backgroundSize="cover"
          backgroundRepeat="no-repeat"
          backgroundPosition="center"
          backgroundImage="url(/images/warning-triangle-orange-large.svg)"
          width="120px"
          height="104px"
          position="relative"
          zIndex="5"
          marginBottom="18px"
        />
        <SrFlex justify="center" direction="col">
          <SrFlex marginBottom="16px" justify="center">
            <SrText
              color="blueGreycliff"
              font="greycliff"
              weight="800"
              fontSize="26px"
              lineHeight="33px"
              align="center"
            >
              Un-Archive Application?
            </SrText>
          </SrFlex>
          <SrFlex marginBottom="18px" justify="center" direction="col">
            <SrText
              color="blueGreycliff"
              font="greycliff"
              weight="600"
              fontSize="16px"
              lineHeight="24px"
              align="center"
            >
              Sunroom will continue to process this application. Sunroom automatically notifies them
              that their application is being processed again.
            </SrText>
          </SrFlex>
          <SrBox>
            <Formik
              validate={(formValues) => {
                const formFields = getFormFields();
                const errors = createFormValidationFn(formFields)(formValues);

                return errors;
              }}
              initialValues={createInitialValues({
                formFields: getFormFields(),
              })}
              onSubmit={onSubmit}
              render={(formikBag) => {
                const formFields = getFormFields();

                return (
                  <Form autoComplete="off">
                    <div>
                      {formFields.map((formField) => (
                        <SrFormikField
                          key={formField.id}
                          formField={formField}
                          formikBag={formikBag}
                          className={formField.classnames || SR_FIELD_THEME_PARTNER_FORM}
                        />
                      ))}
                      <SrBox marginTop="18px" marginBottom="18px">
                        <SrButton type="submit" theme={SR_BUTTON_THEME_ADOBE_ORANGE_INVERTED}>
                          Un-Archive
                        </SrButton>
                      </SrBox>
                      <SrButton theme={SR_BUTTON_THEME_ADOBE_GREY} onClick={onClose}>
                        Cancel
                      </SrButton>
                    </div>
                  </Form>
                );
              }}
            />
          </SrBox>
        </SrFlex>
      </SrBox>
    </SrModalV2>
  );
};

SrUnArchiveAppModalSunScreen.propTypes = {
  onClose: PropTypes.func.isRequired,
  onUnArchive: PropTypes.func.isRequired,
};

SrUnArchiveAppModalSunScreen.displayName = 'SrUnArchiveAppModalSunScreen';

export default SrUnArchiveAppModalSunScreen;
